module.exports = "mutation ForgotPassword($email: String!) {\n  forgotPassword(\n    email: $email,\n  ) \n}\n"